export enum ESlideType {
    Image                   = 0,
    Video                   = 1,
    Destination             = 2,
    Hotel                   = 3,
    DestionationFromPrice   = 4,
    DestionationWithTerm    = 5,
    HotelWithTermAndPrice   = 6,
}
